module.exports = __webpack_public_path__ + "static/media/LINK-BNB.9154787d.svg";